import localFont from "next/font/local";
import { GeistMono } from "geist/font/mono";

// Primary typeface: General Sans (self-hosted), the same clean, modern sans
// turbostarter.dev uses. One control point for the whole site's type.
export const sans = localFont({
  src: "../fonts/GeneralSans-Variable.woff2",
  variable: "--font-sans",
  weight: "200 700",
  display: "swap",
});

// Mono for code / terminal surfaces.
export const mono = GeistMono;
